import React from 'react'
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

const ArrowRightIcon = ({ classNames, ...props }: IconProps): React.ReactElement => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={classNames}
    {...props}
  >
    <path
      d='M10.4602 8.88343H3.41312C3.16771 8.88343 2.95913 8.79756 2.78739 8.62581C2.61565 8.45407 2.52979 8.24549 2.52979 8.00008C2.52979 7.75467 2.61565 7.54609 2.78739 7.37435C2.95913 7.2026 3.16771 7.11673 3.41312 7.11673H10.4602L8.90877 5.5653C8.73776 5.39429 8.65346 5.18849 8.65587 4.94791C8.65829 4.70732 8.74259 4.50152 8.90877 4.33051C9.07979 4.15949 9.2868 4.07277 9.5298 4.07036C9.77279 4.06794 9.9798 4.15224 10.1508 4.32326L13.2102 7.37326C13.2957 7.45877 13.3602 7.55612 13.4037 7.6653C13.4472 7.77447 13.4689 7.88607 13.4689 8.00008C13.4689 8.11409 13.4472 8.22569 13.4037 8.33486C13.3602 8.44404 13.2957 8.54139 13.2102 8.6269L10.1508 11.6769C9.9798 11.8479 9.77279 11.9322 9.5298 11.9298C9.2868 11.9274 9.07979 11.8407 8.90877 11.6696C8.74259 11.4986 8.65829 11.2928 8.65587 11.0522C8.65346 10.8117 8.73776 10.6059 8.90877 10.4349L10.4602 8.88343Z'
      fill='currentColor'
    />
  </svg>
)

export default ArrowRightIcon
